module.exports = __webpack_public_path__ + "static/images/logo.37c39ece8da271e694556c1bca298954.svg";